var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 3.83332H13.4166C13.0179 1.89465 11.3125 0.5025 9.33327 0.5H7.66659C5.68733 0.5025 3.98194 1.89465 3.58327 3.83332H0.999946C0.539712 3.83332 0.166626 4.20641 0.166626 4.66664C0.166626 5.12687 0.539712 5.5 0.999946 5.5H1.83327V16.3333C1.83604 18.6334 3.69991 20.4973 5.99995 20.5H10.9999C13.3 20.4973 15.1639 18.6334 15.1666 16.3333V5.5H15.9999C16.4602 5.5 16.8333 5.12691 16.8333 4.66668C16.8333 4.20645 16.4602 3.83332 15.9999 3.83332ZM7.66663 14.6667C7.66663 15.1269 7.29354 15.5 6.83331 15.5C6.37303 15.5 5.99995 15.1269 5.99995 14.6667V9.66668C5.99995 9.20645 6.37303 8.83336 6.83327 8.83336C7.2935 8.83336 7.66659 9.20645 7.66659 9.66668V14.6667H7.66663ZM10.9999 14.6667C10.9999 15.1269 10.6269 15.5 10.1666 15.5C9.70639 15.5 9.33331 15.1269 9.33331 14.6667V9.66668C9.33331 9.20645 9.70639 8.83336 10.1666 8.83336C10.6269 8.83336 10.9999 9.20645 10.9999 9.66668V14.6667ZM5.30913 3.83332C5.66358 2.83523 6.60749 2.16793 7.66663 2.16664H9.33331C10.3924 2.16793 11.3364 2.83523 11.6908 3.83332H5.30913Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b02935459eca209a0bd60c2f3a88b8cf.svg";
export { ForwardRef as ReactComponent };